export default __webpack_public_path__ + "24-7-account-management-icon.f3da9e5a40477bbee868fd47f92c0793.png";